import { styled } from '@mui/material';

export const AuthLayoutStyled = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.dark.dark_2,
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
